/**
 * Voľba rozhrania (Nastavenia → Vzhľad).
 *
 * Nové rozhranie je jeden CSS súbor pod `html[data-tema="nove"]`, takže
 * prepnutie je len nastavenie atribútu — bez reloadu a bez rizika, že sa
 * rozbije klasický vzhľad. Voľba sa pamätá v prehliadači, teda každý
 * užívateľ (aj technik na svojom telefóne) si ju má vlastnú.
 */
export type Tema = 'klasicke' | 'nove';

const KLUC = 'gpon-tema';

export const nacitajTemu = (): Tema => {
  try {
    return localStorage.getItem(KLUC) === 'nove' ? 'nove' : 'klasicke';
  } catch {
    return 'klasicke';
  }
};

export const pouziTemu = (tema: Tema): void => {
  if (tema === 'nove') {
    document.documentElement.setAttribute('data-tema', 'nove');
  } else {
    document.documentElement.removeAttribute('data-tema');
  }
};

export const nastavTemu = (tema: Tema): void => {
  try {
    localStorage.setItem(KLUC, tema);
  } catch {
    /* súkromné okno — vzhľad vydrží aspoň do zatvorenia karty */
  }
  pouziTemu(tema);
};
